<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import apiFetch from '@wordpress/api-fetch';

const strings = ref(null);
const landingPageUrl = window.marketToolData?.landingPageUrl ?? '/';

const props = defineProps({
  linked: { type: Boolean, default: true },
});

onBeforeUnmount(() => {
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
});

onMounted(async () => {
  try {
    const lang = document.documentElement.lang?.substring(0, 2);
    const translations = await apiFetch({
      path: `/wp-json/ebus/market/translations?lang=${lang}`,
    });

    strings.value = translations;
  } catch (error) {
    console.error('Error: ', error);
  }
});

</script>

<template>
  <header v-if="strings" class="relative! z-40! w-full! bg-light-blue! p-6!">
    <div class="flex! items-center! justify-between! gap-4!">
      <h1 class="font-ibm-plex-mono! font-medium! text-32! lg:text-4xl! leading-tight! text-blue!">
        <a v-if="props.linked" :href="landingPageUrl" class="text-blue! no-underline!">{{ strings.ebus_procurement_observatory }}</a>
        <span v-else>{{ strings.ebus_procurement_observatory }}</span>
      </h1>      
    </div>
  </header>
</template>
